/**
 * Tema automatico por horario: claro de dia y oscuro de noche (desde las
 * 7 p. m. hasta las 6 a. m., con la hora del equipo de quien usa la pagina).
 * index.html repite esta misma regla antes del primer render para no parpadear.
 */
export type ThemePreference = 'auto' | 'light' | 'dark' | 'system';

export const DARK_FROM_HOUR = 19;
export const LIGHT_FROM_HOUR = 6;

export function isNight(date: Date): boolean {
  const h = date.getHours();
  return h >= DARK_FROM_HOUR || h < LIGHT_FROM_HOUR;
}

export function resolveDark(preference: ThemePreference, date: Date, systemDark: boolean): boolean {
  if (preference === 'dark') return true;
  if (preference === 'light') return false;
  if (preference === 'system') return systemDark;
  return isNight(date);
}

/** Milisegundos hasta el proximo cambio automatico (6:00 o 19:00). */
export function msUntilNextSwitch(date: Date): number {
  const next = new Date(date);
  next.setSeconds(0, 0);
  next.setMinutes(0);
  const h = date.getHours();
  if (h < LIGHT_FROM_HOUR) next.setHours(LIGHT_FROM_HOUR);
  else if (h < DARK_FROM_HOUR) next.setHours(DARK_FROM_HOUR);
  else {
    next.setDate(next.getDate() + 1);
    next.setHours(LIGHT_FROM_HOUR);
  }
  return Math.max(1000, next.getTime() - date.getTime());
}

export function parsePreference(value: string | null): ThemePreference {
  return value === 'light' || value === 'dark' || value === 'system' || value === 'auto' ? value : 'auto';
}
